import { Icon } from "@iconify/react";
import { CtyButton } from "../button/CtyButton";
import { Badge, Button, Popover, PopoverContent, PopoverTrigger } from '@nextui-org/react';
import { useState, useEffect } from "react";
import { useCartOperations, CartDownloadType } from "./useCartOperations";
import { useTheme } from "../context/ThemeContext";

interface CartItemsListProps {
    openCart?: boolean;
    popupPlacement?: any;
}

const CartItemsList = (props: CartItemsListProps) => {
    const { openCart = false, popupPlacement = 'bottom' } = props;
    const { isDark } = useTheme();

    const [isCartOpen, setIsCartOpen] = useState<boolean>(openCart ?? false);

    useEffect(() => {
        if (openCart) {
            setIsCartOpen(openCart);
        }
    }, [openCart]);

    const {
        itemsArray,
        itemCount,
        placeOrder,
        setPlaceOrder,
        isFetchingCartCsvFile,
        isPlacingOrder,
        incrementQuantity,
        decrementQuantity,
        handleDelete,
        handleDownload,
    } = useCartOperations();

    return (
        <Popover placement={popupPlacement} isOpen={isCartOpen} onOpenChange={(isOpen: boolean) => setIsCartOpen(isOpen)}>
            <Badge
                color="danger"
                content={itemCount}
                size="md"
                isInvisible={itemCount === 0}
            >
                <PopoverTrigger>
                    <Button id="cart-list-btn" isIconOnly radius="sm" size="sm" variant="light">
                        <Icon icon="bytesize:cart" width="1.4rem" height="1.4rem" style={{ color: isDark ? "#f5f5f5" : "#000" }} />
                    </Button>
                </PopoverTrigger>
            </Badge>
            <PopoverContent className="bg-content1 w-[300px]">
                <div className="flex flex-col w-full">
                    <div className="p-3 text-lg font-semibold border-b">My Cart</div>
                    <div aria-label="carts-list" className={`w-full ${itemCount > 3 ? "max-h-[300px] overflow-y-auto" : ""}`}>
                        {itemsArray.map(([key, item]) => (
                            <div key={key} className="p-0 m-0 border-b">
                                <div className="flex flex-row justify-between items-start p-2 ">
                                    <div className="flex-1 flex flex-col gap-1">
                                        <div>{item.partName}</div>
                                        <div>Code: <span className="font-light text-xs">{item.partNumber}</span></div>
                                        <div className="flex items-center gap-1">
                                            <CtyButton isIconOnly size="sm" variant="light" onPress={() => decrementQuantity(item)}>
                                                <Icon icon="tabler:minus" width="16" height="16" className="text-primary" />
                                            </CtyButton>
                                            <span className="text-primary font-semibold w-[20px] bg-[#F5F5F5] flex justify-center">
                                                {item.totalQuanity}
                                            </span>
                                            <CtyButton isIconOnly size="sm" variant="light" onPress={() => incrementQuantity(item)}>
                                                <Icon icon="tabler:plus" width="16" height="16" className="text-primary" />
                                            </CtyButton>
                                        </div>
                                    </div>
                                    <Button
                                        id={`${key}-delete-btn`}
                                        isIconOnly
                                        radius="sm"
                                        size="sm"
                                        variant="light"
                                        onPress={() => handleDelete(item)}
                                    >
                                        <Icon icon="hugeicons:delete-02" width="1.1rem" height="1.1rem" />
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </div>
                    {!placeOrder &&
                        <CtyButton className="my-2" variant="bordered" radius="sm" size="lg" onPress={() => setPlaceOrder(true)} isDisabled={itemCount === 0}>
                            Place Order
                        </CtyButton>
                    }
                    {placeOrder &&
                        <>
                            <CtyButton className="my-2" isLoading={isFetchingCartCsvFile} variant="bordered" radius="sm" size="lg" onPress={() => handleDownload(CartDownloadType.CSV)}>
                                Download CSV
                            </CtyButton>
                            <CtyButton className="my-2" isLoading={isPlacingOrder} variant="bordered" color={'primary'} radius="sm" size="lg" onPress={() => handleDownload(CartDownloadType.JSON)}>
                                Download JSON
                            </CtyButton>
                        </>
                    }
                </div>
            </PopoverContent>
        </Popover>
    );
};


export { CartItemsList };
